import { render, staticRenderFns } from "./ConfigurarRecibosList.vue?vue&type=template&id=7218ec46&scoped=true"
import script from "./ConfigurarRecibosList.vue?vue&type=script&lang=js"
export * from "./ConfigurarRecibosList.vue?vue&type=script&lang=js"
import style0 from "./ConfigurarRecibosList.vue?vue&type=style&index=0&id=7218ec46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7218ec46",
  null
  
)

export default component.exports